/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { VideoProvider } from '../../contexts/videoProvider/videoContext';
import { TaskInputs } from './TaskInputs/TaskInputs';
import { InputConfig } from './TaskInputs/types';
import { BerbixIDV } from './BerbixIDV/BerbixIDV';
import { SocureIDV } from './SocureIDV/SocureIDV';
import { LocalRoomSetup } from './LocalRoomSetup/LocalRoomSetup';
import { VerificationFailure } from './VerificationFailure/VerificationFailure';
import { InfoCard } from './InfoCard/InfoCard';
import { KBA } from './KBA/KBA';
import { WaitingRoom } from './WaitingRoom/WaitingRoom';
import { KBAInterstitial } from './KBA/KBAInterstitial';
import { get } from '@utils/lodash';

export type TaskTemplateType =
  | 'basic'
  | 'deviceSetup'
  | 'idvWait'
  | 'berbixIDV'
  | 'idvSuccess'
  | 'waitingRoom'
  | 'signingRoom'
  | 'infoCard'
  | 'lockout'
  | 'kba'
  | 'kbaInterstitial';

export type TemplateTypeMap = {
  [key in TaskTemplateType]: (inputs: InputConfig[], options: any) => JSX.Element;
};

export const templateTypeMap: TemplateTypeMap = {
  basic: inputs => <TaskInputs inputs={inputs} />,
  deviceSetup: (inputs, opts) => (
    <VideoProvider
      opts={{ networkQuality: true }}
      connectWithTracks={false}
      videoProviderName={get(opts, 'task.template.customProps.videoProvider')}
    >
      <LocalRoomSetup
        videoAuthToken={get(opts, 'task.template.customProps.videoAuthToken')}
        testSessionId={get(opts, 'task.template.customProps.testSessionId')}
      />
      <TaskInputs inputs={inputs} />
    </VideoProvider>
  ),
  idvWait: (_inputs, opts) => <SocureIDV opts={opts} />,
  berbixIDV: (_inputs, opts) => <BerbixIDV opts={opts} />,
  idvSuccess: () => <div />,
  kba: (inputs, opts) => <KBA inputs={inputs} opts={opts} />,
  waitingRoom: (_inputs, opts) => <WaitingRoom task={get(opts, 'task')} />,
  signingRoom: () => <div />,
  infoCard: (_inputs, opts) => <InfoCard cardInfo={get(opts, 'task.template.customProps.cardInfo')} />,
  lockout: (_inputs, opts) => <VerificationFailure assignee={get(opts, 'task.template.customProps.assignee')} />,
  kbaInterstitial: (_inputs, opts) => <KBAInterstitial setContinueButtonDisabled={opts.setContinueButtonDisabled} />,
};
